import type { HTMLInputTypeAttribute } from "react";
import { cn } from "../../utils";

export function inputTypeClass(type: HTMLInputTypeAttribute = "text"): string {
  return cn(
    `shadow-xs aria-invalid:ring-error/50 aria-invalid:border-error box-border inline-block
    min-h-[2.125em] min-w-0 max-w-full rounded-[0.5em] border bg-primary px-[0.5em] py-[0.25em]
    align-middle leading-normal text-primary outline-none ring-offset-1 ring-offset-primary
    transition-[color,box-shadow] selection:bg-brand-alt selection:text-white
    placeholder:text-primary/50 focus:border-brand focus:ring-[0.125em] focus:ring-brand/50
    focus-visible:border-brand focus-visible:ring-[0.125em] focus-visible:ring-brand/50
    disabled:pointer-events-none disabled:opacity-50 aria-disabled:pointer-events-none
    aria-disabled:opacity-50 data-[placeholder]:text-primary/50`,

    (type === "button" || type === "submit" || type === "reset") &&
      `border-brand-alt hover:border-brand-hover relative inline-flex cursor-pointer items-center
      justify-center truncate bg-brand-alt text-white hover:bg-brand-hover`,

    type === "color" && "h-[2.125em] min-w-[2.5em] p-[0.25em]",

    type === "file" &&
      `file:border-brand-alt file:inline-flex file:-translate-y-[0.1em] file:cursor-pointer
      file:rounded-lg file:border-0 file:bg-brand-alt file:px-[1em] file:py-[0.4em] file:font-medium
      file:leading-[0.8em] file:text-white file:[font-size:0.8em] file:hover:bg-brand-hover`,

    type === "date" && "max-w-fit",

    type === "time" && "max-w-fit"
  );
}
